import { Button, Grid, Tooltip } from "@mui/material";
import List from "@mui/material/List";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { Formik } from "formik";
import * as React from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useHistory } from "react-router";
import DropdownCmp2 from "../../components/dropdown/DropdownCmp2";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import { NOTICE_FILTER } from "../../config/cacheKey";
import {
  Filter,
  getAllSupplierNoticesRequest,
  getNoticesResponse,
  getSelectResponse,
  noticeSummaryResponse,
} from "../../models/SupplierNotice.model";
import { ApiResultModel, PageInfoModel } from "../../models/common.model";
import { PaginationInfo } from "../../models/loan.model";
import {
  GetAllSupplierNotices,
  GetNoticeTypes,
  GetSupplierNoticeSummary,
} from "../../services/SupplierNotice.service";
import NotifChild from "./notifChild";
import { connect, useDispatch } from "react-redux";
import { setNoticeSummary } from "../../redux/summaryCount/summaryCountAction";
import { withRouter } from "react-router-dom";

function NotificationsHistory({
  summatyNotice,
}: CurrentNoticeCmpPropsInterface) {
  const history = useHistory<{
    from: string;
    id: string;
    pageNumber: number;
    clickOnBack: boolean;
  }>();
  const [valueTypeNotice, setValueTypeNotice] = React.useState<number[]>([]);
  const [valueTitle, setValueTitle] = React.useState<string>();
  const [valueFilterData, setValueFilterData] = React.useState<Filter>();
  const [hoverRow, setHoverRow] = React.useState<boolean>(false);
  const [data, setData] = React.useState<getNoticesResponse[]>([]);
  const [typeNotice, setTypeNotice] = React.useState<getSelectResponse[]>([]);
  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const queryClient = useQueryClient();
  function changeValueTypeNotice(e: any) {
    const typeNotice = [];
    typeNotice.push(e.target.value);
    setValueTypeNotice(typeNotice);
  }
  function changeValueTitle(e: any) {
    setValueTitle(e.currentTarget.value);
  }
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber = 1;
      // history.location.state !== undefined
      //   ? history.location.state.pageNumber
      //   : 1;
      return paginationInfo;
    }
  );
  useQuery<getSelectResponse[]>("typeNotice", GetNoticeTypes, {
    onSuccess(data) {
      setTypeNotice(data);
    },
  });
  //==========
  const toggleHover = () => {
    setHoverRow(!hoverRow);
  };
  //==========
  const getAllSupplierNoticesMutation = useMutation(GetAllSupplierNotices, {
    onSuccess: (result: ApiResultModel<getNoticesResponse[]>) => {
      if (result) {
        setData(result.data);
        setPageInfo(result.pageInfo);
      }
    },
  });
  const generateFilter = (filterData: Filter): getAllSupplierNoticesRequest => {
    let request = new getAllSupplierNoticesRequest();
    request.paginationInfo = currentPaginationInfo;
    request.filter = filterData;
    return request;
  };

  const fillData = (filterData: Filter) => {
    let filter = generateFilter(filterData);
    getAllSupplierNoticesMutation.mutate(filter);
    // setValueFilterData(filter?.filter);
  };
  //=========redux for call summary api
  const dispatch = useDispatch();
  const getSupplierNoticeSummaryMutate = useMutation(GetSupplierNoticeSummary, {
    onSuccess: (data: noticeSummaryResponse) => {
      // setCount(data.count);
      // setHasInstant(data.hasInstant);
      dispatch(
        setNoticeSummary({ count: data.count, hasInstant: data.hasInstant })
      );
    },
  });

  //=========redux for call summary api
  React.useEffect(() => {
    const filterData = new Filter();
    fillData(filterData!);
    // getSupplierNoticeSummaryMutate.mutate();
  }, []);

  const changePageNumber = (newPageNumber: number) => {
    const noticeFilter = queryClient.getQueryData<Filter>(NOTICE_FILTER);
    fillData(noticeFilter!);
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
  };
  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
  };
  const count = Math.ceil(pageInfo.total / pageInfo.pageSize);

  const nextIcon = () => {
    return (
      <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
    );
  };
  const previusIcon = () => {
    return (
      <img
        style={{ height: "12px", width: "10px" }}
        src="images/Previous.png"
      />
    );
  };
  const handleRemoveFilter = () => {
    queryClient.setQueryData(NOTICE_FILTER, null);
    const noticeFilter = queryClient.setQueryData(NOTICE_FILTER, null);
    // setValueFilterData(noticeFilter);
    fillData(noticeFilter!);
    currentPaginationInfo.pageNumber = 1;
    setCurrentPaginationInfo(currentPaginationInfo);
    setValueTitle("");
    setValueTypeNotice([]);
  };
  const filter = new Filter();

  return (
    <div>
      <Formik
        initialValues={filter}
        onSubmit={(values: any) => {
          queryClient.setQueryData(NOTICE_FILTER, values);
          values.noticeType = valueTypeNotice;
          values.title = valueTitle;
          fillData(values);
          currentPaginationInfo.pageNumber = 1;
          setCurrentPaginationInfo(currentPaginationInfo);
        }}
      >
        {({ handleSubmit, handleChange, values, handleReset }) => (
          <form onSubmit={handleSubmit} onChange={handleChange}>
            <div className="row" style={{ paddingBottom: " 5px " }}>
              <div
                className=" col-4  col-lg-2 col-md-3  butFilter"
                style={{ marginTop: "1vh", paddingRight: "3vh" }}
              >
                <DropdownCmp2
                  // error={
                  //   touched.noticeType &&
                  //   Boolean(noticeType === undefined ? true : false)
                  //   noticeType === undefined ? true : false
                  // }
                  // onBlur={handleBlur}
                  onChange={changeValueTypeNotice}
                  value={valueTypeNotice}
                  label={"نوع اعلان"}
                  options={typeNotice}
                  name="noticeType"
                  id="noticeType"
                />
              </div>
              <div
                className=" col-4  col-lg-2 col-md-3  butFilter"
                style={{ marginTop: "1vh" }}
              >
                <MaterialTextFieldComponent
                  className={"shadowTextField"}
                  autoFocus={true}
                  // helperText={!touched.title ? errors.title : ""}
                  // error={!touched.title && Boolean(errors.title)}
                  label="عنوان "
                  placeHolder={"عنوان "}
                  required={true}
                  type="text"
                  value={valueTitle}
                  onChange={changeValueTitle}
                  name="title"
                  id="title"
                />
              </div>
              <div
                className=" col-4  col-lg-2 col-md-3  butFilter"
                style={{ marginTop: "1vh" }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  type="submit"
                  className="btnForm SuccessDefault  "
                >
                  فیلتر
                </Button>
              </div>
              <div
                className=" col-4  col-lg-2 col-md-3  butFilter"
                style={{ marginTop: "1vh" }}
              >
                {values ? (
                  <Tooltip title="حذف فیلتر" arrow>
                    <Button
                      type="button"
                      onClick={() => {
                        handleRemoveFilter();
                        handleReset();
                      }}
                      style={{
                        justifyContent: "right",
                        minWidth: "25px",
                        marginRight: "-1vh",
                      }}
                    >
                      <img
                        style={{ height: "24px", width: "24px" }}
                        src="images/RemoveAllFilters.svg"
                      />
                    </Button>
                  </Tooltip>
                ) : null}
              </div>
            </div>
          </form>
        )}
      </Formik>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "10px ",
        }}
      >
        <List
          sx={{
            width: "100%",
            // maxWidth: "100rem",
            padding: "10px",
            backgroundColor: "#F9FCFE",
            border: "1px solid #DAE0E4",
            borderRadius: "5px",
          }}
        >
          {data.map((value: any, index: any) => {
            return <NotifChild value={value} />;
          })}
        </List>
        <Grid container xs={12}>
          <Grid item xs={4}>
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :
              <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
            </span>
          </Grid>
          <Grid item xs={4}>
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              // color="primary"
              sx={{
                display: "flex",
                justifyContent: "center !important",
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
                //  button.sele
              }}
              count={Math.ceil(pageInfo.total / pageInfo.pageSize)}
              onChange={handleChangePagination}
              page={currentPaginationInfo.pageNumber}
            />
          </Grid>
          <Grid item xs={4}></Grid>
        </Grid>
      </div>
    </div>
  );
}
interface CurrentNoticeCmpPropsInterface {
  summatyNotice: any;
}
const mapStateToProps = ({ summatyNotice }: CurrentNoticeCmpPropsInterface) => {
  return { summatyNotice };
};

export default withRouter(connect(mapStateToProps)(NotificationsHistory));
